import { render, staticRenderFns } from "./invitedUser.vue?vue&type=template&id=6d830568&"
import script from "./invitedUser.vue?vue&type=script&lang=js&"
export * from "./invitedUser.vue?vue&type=script&lang=js&"
import style0 from "./invitedUser.vue?vue&type=style&index=0&id=6d830568&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports